import React from 'react';
import { Outlet, useParams, Link, useLocation } from 'react-router-dom';

const SettingView = () => {
  const params = useParams();
  const loc = useLocation();

  return (
    <>
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="main-content-label">Global Settings</h6>
              </div>
              <div className="tabs-wrap">
                <div className="profile-tab tab-menu-heading mb-4">
                  <nav className="nav main-nav-line p-3 tabs-menu profile-nav-line bg-gray-100">
                    <Link
                      className={
                        "nav-link linkactive " +
                        (loc.pathname.includes(`/admin/cms/settings/general-settings`) ? " active" : "")
                      }
                      to={`/admin/cms/settings/general-settings`}
                    >
                      General Settings
                    </Link>
                    <Link
                      className={
                        "nav-link linkactive " +
                        (loc.pathname.includes(`/admin/cms/settings/platform-settings`) ? " active" : "")
                      }
                      to={`/admin/cms/settings/platform-settings`}
                    >
                      HTML Settings
                    </Link>
                    <Link
                      className={
                        "nav-link linkactive " +
                        (loc.pathname.includes(`/admin/cms/settings/common-settings`) ? " active" : "")
                      }
                      to={`/admin/cms/settings/common-settings`}
                    >
                      Additional Feature Settings
                    </Link>
                  </nav>
                </div>
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingView;
